/* unplugin-vue-components disabled */import script from "./WorkspaceMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceMenu.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceMenu.vue?vue&type=style&index=0&id=7adb499e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7adb499e"]])

export default __exports__